import { http } from '../../core';
import Config from "../../app.config";
const RequestbaseURL = http.create({ baseURL: Config.BASE_API });

export function improveAdd(params) {
    return RequestbaseURL.post('/fault/v1/improve/add', params)
}

export function improveList(params) {
    return RequestbaseURL.get('/fault/v1/improve/list', { event_id: params })
}

export function improveInfo(id) {
    return RequestbaseURL.get('/fault/v1/improve/info', { id })
}

export function improveEdit(params) {
    return RequestbaseURL.post('/fault/v1/improve/edit', params)
}

export function improveDelete(params) {
    return RequestbaseURL.post('/fault/v1/improve/delete', params)
}